import { render, staticRenderFns } from "./QuestionBankView.vue?vue&type=template&id=5f108041&scoped=true&"
import script from "./QuestionBankView.vue?vue&type=script&lang=js&"
export * from "./QuestionBankView.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBankView.vue?vue&type=style&index=0&id=5f108041&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f108041",
  null
  
)

export default component.exports